import AddCircleIcon from '@material-ui/icons/AddCircle';
export default function AddRowCircle({rowIndex,side,alwaysVisible,onClick}){
  return <AddCircleIcon 
    onClick={onClick}
    location={side+'-'+rowIndex}
    action={"add-row"}

    style={{
      cursor:'pointer',
      position:'absolute',
      top:'50%',
      left:'50%',
      transform:'translate(-50%,-50%)',

      background:'white',
      borderRadius:10,
      padding:0,
      margin:0,
      color:'#088c44',fontSize:15
    }}/>
}
